// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react';
import DoneAll from '@mui/icons-material/DoneAll';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Moment from 'react-moment';
import '../../../../styles/InputRange.css';
import NoteIcon from '@mui/icons-material/Note';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChatMessageModel from '../../../../api/models/ChatMessageModel';
import MessageDateIndicator from '../MessageDateIndicator';
import ContextChatMessage from './ContextChatMessage';
import ReplyIcon from '@mui/icons-material/Reply';
import ChatMessageVideo from './ChatMessageVideo';
import ChatMessageImage from './ChatMessageImage';
import ChatMessageDocument from './ChatMessageDocument';
import ChatMessageVoice from './ChatMessageVoice';
import ChatMessageTemplate from './ChatMessageTemplate';
import ChatAssignmentEvent from '../../../ChatAssignmentEvent';
import ChatTaggingEvent from '../../../ChatTaggingEvent';
import ChatMessageLocation from './ChatMessageLocation';
import { useTranslation } from 'react-i18next';
import InteractiveMessage from './InteractiveMessage';
import OrderMessage from './OrderMessage';
import ContactsMessage from './ContactsMessage';
import PrintMessage from '../../../PrintMessage';
import Alert from '@mui/material/Alert';
import { Button, CircularProgress, Typography } from '@mui/material';
import ChatMessageReferral from './ChatMessageReferral';
import { setPreviewMediaObject } from '@src/store/reducers/previewMediaObjectReducer';
import PreviewMediaModel from '../../../../api/models/PreviewMediaModel';
import { ATTACHMENT_TYPE_IMAGE, ATTACHMENT_TYPE_VIDEO, RESTAURANT } from '@src/Constants';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import CustomModal from '@src/components/CustomModal/CustomModal';
import ViewOrder from '@src/components/OrderView/ViewOrder';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import CustomAlert from '@src/components/CustomAlert/CustomAlert';
import { CustomAlertType } from '@src/pages/Catalogs';
import FeedBackMessage from './FeedBackMessage/FeedBackMessage';
import CustomDrawer from '@src/components/CustomDrawer/CustomDrawer';
import { formatPriceValue, generateInitialsHelper } from '@src/helpers/Helpers';
import moment from 'moment';
import CustomAvatar from '@src/components/CustomAvatar';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import OrderApproval from '@src/pages/Orders/Components/OrderApproval';
import { IsMobileWidth, IsTabletWidth } from '@src/components/MediaQueryUtils';
import { OrderView } from '@src/pages/Orders';
import SlidableDrawer from '@src/components/CustomModal/SlidableDrawer';
import { Product, ProductResponse } from '@src/interfaces/type';

const iconStyles = {
	fontSize: '15px',
};

type Restaurant = {
	id: number;
	name: string;
	phone: string;
	image: string;
};

export interface OrderFulfillmentLifeCycle {
	accepted: FulfillmentStatus;
	readyToShip: ReadyToShipStatus;
	shipped: ShippedStatus;
}

export interface ReadyToShipStatus {
	statusId: number;
	statusGroup: StatusGroup;
	invoiceNumber: string;
	attachments: ReadyToShipAttachments;
}

interface ReadyToShipAttachments {
	lrCopy: string;
	eWayBill: string;
}

export interface FulfillmentStatus {
	statusId: number;
	statusGroup: StatusGroup;
	salesOrderNumber: string;
	packingInstructions: string;
	logisticInstructions: string;
	paymentTerms: PaymentTerms;
	remarks: string;
	soDate: string;
	customerPoNumber: string;
	attachments: Attachments;
}

interface StatusGroup {
	id: number;
	name: string;
}

interface PaymentTerms {
	id: number;
	name: string;
}

interface Attachments {
	salesOrder: string | null;
	lrCopy?: string;
	eWayBill?: string;
}

export interface ShippedStatus {
	statusId: number;
	statusGroup: StatusGroup;
	paymentMode: PaymentMode | null;
	paymentStatus: PaymentStatus | null;
	receivedAmount: number | null;
	attachments: PaymentAttachments;
}

interface PaymentMode {
	id: number | null;
	name: string | null;
}

interface PaymentStatus {
	id: number | null;
	name: string | null;
}

interface PaymentAttachments {
	paymentAttachment: string | null;
}

export interface Order {
	id: string;
	orderId: string;
	cheeniOrderId?: string;
	orderDate: string;
	deliveryDate: string;
	requestedDeliveryDate: string;
	customerId: string;
	firstname: string;
	lastname: string;
	restaurant: Restaurant;
	sentForReview: number;
	supplier: any;
	timeId: string;
	isMarketplace?: number;
	statusData?: {
		color: string | undefined;
		color_bg: string | undefined;
		name: string | undefined;
		validation_order: number | undefined;
		id: number;
		group_id: number;
	};
	orderStatus: {
		color: string | undefined;
		color_bg: string | undefined;
		name: string | undefined;
		validation_order: number | undefined;
		id: number;
		group_id: number;
	};
	comments: string;
	total: string;
	vendorId: string;
	products: Product[];
	orderFulfillmentLifeCycle: OrderFulfillmentLifeCycle;
}

function ChatMessage({
	data,
	templateData,
	displaySender,
	displayDate,
	contactProvidersData,
	onOptionsClick,
	goToMessageId,
	isTemplatesFailed,
	retryMessage,
	disableMediaPreview,
	displayCustomError,
	updateWidget,
	setUpdateWidget,
	setFieldBackField,
}) {
	const { apiService } = React.useContext(ApplicationContext);
	const { t } = useTranslation();
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	const isTabletWidth = IsTabletWidth();
	const isMobileWidth = IsMobileWidth();

	const dispatch = useAppDispatch();
	const [viewOrder, setViewOrder] = useState(false);
	const [viewAprovalOrder, setViewAprovalOrder] = useState(false);
	const [loading, setLoading] = useState(false);
	const [alert, setAlert] = useState<CustomAlertType>({ message: '', severity: 'success' });
	const [orderData, setOrderData] = useState<Order | null>(null);
	const [orderDetails, setOrderDetails] = useState<Order | null>(null);
	const [orders, setOrders] = useState<Order[]>([]);
	const [orderInfo, setOrderInfo] = useState(null);
	const [products, setProducts] = useState<OrderProduct[]>([]);
	const [view, setView] = useState<OrderView>('orderDetails');

	const [apiCall, setApiCall] = useState(false);
	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});
	const checkPermission = usePermission();
	const canViewOrder = checkPermission(
		ALL_PERMISSION_MAP?.GENERAL?.ORDER?.VIEW,
		data?.payload?.order?.timeId || data?.payload?.order?.orderId
	);

	const updateWindowDimensions = () => {
		setWindowDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};

	const orderMessageStyles = {
		minWidth: '290px', //266px
		height: 'auto',
		minHeight: '239px',
		borderRadius: data.isFromUs ? '10px 10px 0px 10px' : '10px 10px 10px 0px',
		border: '1px solid #cc9800',
		background: data.isFromUs ? '#fff9e6' : '#fff',
		boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.04)',
		padding: 0,
		letterSpacing: '0.20px',
	};

	const feedbackMessageStyles = {
		borderTop: '8px solid #ffdf80',
		background: data.isFromUs ? '#fff9e6' : '#fff',
		boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.04)',
		borderRadius: '8px 8px 0px 8px',
	};

	const msgContainerStyling = () => {
		if (data?.type === ChatMessageModel.TYPE_ORDER) {
			return orderMessageStyles;
		} else if (data?.type === ChatMessageModel.ORDER_FEEDBACK) {
			return feedbackMessageStyles;
		}
		return {};
	};
	const MessageContainer = () => {
		return (
			<div
				style={msgContainerStyling()}
				className={
					'chat__message' +
					(data.hasMediaToPreview() ? ' hasMedia' : '') +
					(data.isFromUs === true
						? (data.isRead() ? ' chat__received' : '') + ' chat__outgoing'
						: '') +
					(!displaySender && !displayDate ? ' hiddenSender' : '') +
					(' messageType__' + data.type) +
					(data.isFailed ? ' chat__failed' : '')
				}
			>
				{data.isForwarded && (
					<div className="chat__forwarded">
						<ReplyIcon />
						<span>{t('Forwarded')}</span>
					</div>
				)}

				{data.contextMessage !== undefined && (
					<ContextChatMessage contextMessage={data.contextMessage} goToMessageId={goToMessageId} />
				)}

				{data.referral && (
					<ChatMessageReferral
						data={data}
						onPreview={onPreview}
						onOptionsClick={(e) => onOptionsClick(e, data)}
					/>
				)}

				{data.type === ChatMessageModel.TYPE_IMAGE && (
					<ChatMessageImage
						data={data}
						source={data.generateImageLink()}
						onPreview={() => onPreview(ATTACHMENT_TYPE_IMAGE, data.generateImageLink())}
					/>
				)}

				{data.type === ChatMessageModel.TYPE_VIDEO && (
					<ChatMessageVideo
						data={data}
						source={data.generateVideoLink()}
						onPreview={() => onPreview(ATTACHMENT_TYPE_VIDEO, data.generateVideoLink())}
						onOptionsClick={(e) => onOptionsClick(e, data)}
					/>
				)}

				{(data.type === ChatMessageModel.TYPE_VOICE ||
					data.type === ChatMessageModel.TYPE_AUDIO) && <ChatMessageVoice data={data} />}

				{data.type === ChatMessageModel.TYPE_DOCUMENT && <ChatMessageDocument data={data} />}

				{data.type === ChatMessageModel.TYPE_STICKER && (
					<span>
						<NoteIcon fontSize="small" />
					</span>
				)}

				{data.type === ChatMessageModel.TYPE_LOCATION && <ChatMessageLocation data={data} />}

				{data.type === ChatMessageModel.TYPE_TEMPLATE && (
					<ChatMessageTemplate
						data={data}
						templateData={templateData}
						isTemplatesFailed={isTemplatesFailed}
						onPreview={onPreview}
						onOptionsClick={(e) => onOptionsClick(e, data)}
					/>
				)}

				{data.type === ChatMessageModel.TYPE_INTERACTIVE && <InteractiveMessage data={data} />}

				{data.type === ChatMessageModel.TYPE_ORDER ? (
					!loading ? (
						<OrderMessage
							orderDetails={orderDetails}
							orderBy={getUserName()}
							orderInfo={orderInfo}
							currentUser={currentUser}
							data={data}
							setViewOrder={setViewOrder}
							setViewAprovalOrder={setViewAprovalOrder}
							chatTimeStamp={<Moment date={data.timestamp} format={dateFormat} unix />}
							setFieldBackField={setFieldBackField}
							setOrderDetails={setOrderDetails}
							orderData={orderData}
						/>
					) : (
						<div className="progress">
							<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
						</div>
					)
				) : null}

				{data?.type === ChatMessageModel.ORDER_FEEDBACK ? (
					<FeedBackMessage feedBackData={data?.payload?.orderFeedback} />
				) : null}

				{data.type === ChatMessageModel.TYPE_CONTACTS && <ContactsMessage data={data} />}

				{data.text ?? data.caption ?? data.buttonText ?? data.interactiveButtonText ? (
					<PrintMessage
						className="wordBreakWord"
						message={data.text ?? data.caption ?? data.buttonText ?? data.interactiveButtonText}
						linkify={true}
					/>
				) : (
					'\u00A0'
				)}

				{data.errors &&
					data.errors.map((error, index) => {
						// Could not find translation for the requested language and locale
						if (error.code === 2003) {
							return (
								<Alert
									key={index}
									variant="filled"
									severity="warning"
									className="chat__errors"
									action={
										data.isFailed &&
										data.canRetry() && (
											<Button color="inherit" size="small" onClick={() => retryMessage(data)}>
												{t('Retry')}
											</Button>
										)
									}
								>
									<div>
										{t(
											'The language pack for this template is not installed on the server yet, try sending this message later'
										)}
									</div>
								</Alert>
							);
						}

						return (
							<Alert
								key={index}
								variant="filled"
								severity="error"
								className="chat__errors"
								action={
									data.isFailed &&
									data.canRetry() && (
										<Button color="inherit" size="small" onClick={() => retryMessage(data)}>
											{t('Retry')}
										</Button>
									)
								}
							>
								<div>{t(error.details ?? error.title)}</div>
							</Alert>
						);
					})}

				<span
					style={data.type === ChatMessageModel.TYPE_ORDER || true ? { paddingRight: '10px' } : {}}
					className="chat__message__info"
				>
					<span className="chat__timestamp">
						<Moment date={data.timestamp} format={dateFormat} unix />
					</span>

					{!data.isFailed && data.isFromUs === true && (
						<>
							{data.isPending() && (
								<AccessTimeIcon className="chat__iconPending" color="inherit" style={iconStyles} />
							)}

							{data.isJustSent() && (
								<DoneIcon className="chat__iconDone" color="inherit" style={iconStyles} />
							)}

							{data.isDeliveredOrRead() && (
								<DoneAll className="chat__iconDoneAll" color="inherit" style={iconStyles} />
							)}
						</>
					)}

					{data.isFailed && (
						<ErrorIcon className="chat__iconError" color="inherit" style={iconStyles} />
					)}
				</span>

				<div style={{ clear: 'both' }} />
			</div>
		);
	};
	const onPreview = (type, source) => {
		if (!disableMediaPreview) {
			const previewData = new PreviewMediaModel(
				data.senderName,
				data.initials,
				type,
				source,
				data.timestamp
			);

			dispatch(setPreviewMediaObject(previewData));
		}
	};

	const getUserName = () => {
		if (currentUser?.type?.toLowerCase() === RESTAURANT) {
			return '';
		}
		return data?.contact?.waba_payload?.profile?.companyName;
	};

	const dateFormat = 'LT';
	const hideMessages = () => {
		return data?.text !== 'sudo-template-chat-init';
	};

	function getOrderDetailsArray(orderResponse) {
		const status = orderResponse?.orderStatus;
		const order = [];
		order.push({
			key: 'Order Status',
			value: status,
			id: 'status',
			className: 'status',
		});

		if (orderResponse?.credits.isActive) {
			order.push({
				key: 'Credit Status',
				value: orderResponse?.credits?.creditAvailable < 0 ? 'NO CREDIT' : 'AVAILABLE',
				// id: 'status',
				className:
					'credit_status-' +
					(orderResponse?.credits?.creditAvailable < 0 ? 'NO_CREDIT' : 'AVAILABLE'),
			});
		}

		order.push({
			key: 'Payment Status',
			value: orderResponse?.paymentStatus?.name || 'N/A',
			className: 'payment_status-' + orderResponse?.paymentStatus?.name,
		});
		if (orderResponse?.requestedDeliveryDate) {
			order.push({
				key: 'Deliver On',
				value: moment(orderResponse?.requestedDeliveryDate).format('MMM DD, YYYY'),
				id: '',
			});
		}
		order.push({ key: 'Products Ordered', value: orderResponse?.products?.length, id: '' });
		return order;
	}

	useEffect(() => {
		if (canViewOrder) {
			if (data.type === ChatMessageModel.TYPE_ORDER) {
				setLoading(true);
				const orderId = data?.payload?.order?.orderId;
				const cheeniOrderId = data?.payload?.order?.cheeniOrderId;
				const restaurantId = data?.contact?.waba_payload?.profile?.restaurantId;
				apiService.getOrderDetails(
					(response: AxiosResponse) => {
						const orderResponse = response?.data?.data;
						const status = orderResponse?.orderStatus;
						const order = getOrderDetailsArray(orderResponse);

						const updatedOrderProducts = orderResponse?.products?.map((item: ProductResponse) => {
							return {
								...item,
								id: item?.productId,
								price: formatPriceValue(item?.price),
								category: item?.category?.name,
								categoryId: item?.category?.id,
								subCategory: item?.subCategory?.name,
								subCategoryId: item?.subCategory?.id,
								maxPrice: formatPriceValue(item?.maxPrice),
								machineBrand: item?.machineBrand?.name,
								machineBrandId: item?.machineBrand?.id,
								machineModel: item?.machineModel?.name,
								machineModelId: item?.machineModel?.id,
								groupCategory: item?.groupCategory?.name,
								groupCategoryId: item?.groupCategory?.id,
								brand: item?.brand?.name,
								brandId: item?.brand?.id,
								partComposition: item?.partComposition?.name,
								partCompositionId: item?.partComposition?.id,
								partDesign: item?.partDesign?.name,
								partDesignId: item?.partDesign?.id,
								partDiameter: item?.partDiameter?.name,
								partDiameterId: item?.partDiameter?.id,
								partDimension: item?.partDimension?.name,
								partDimensionId: item?.partDimension?.id,
								partOwnership: item?.partOwnership?.name,
								partOwnershipId: item?.partOwnership?.id,
								partQuality: item?.partQuality?.name,
								partQualityId: item?.partQuality?.id,
								partWeight: item?.partWeight?.name,
								partWeightId: item?.partWeight?.id,
								partPerformance: item?.partPerformance?.name,
								partPerformanceId: item?.partPerformance?.id,
							};
						});

						setOrderDetails({
							...orderResponse,
							cheeniOrderId: cheeniOrderId,
							deliveryDate: moment(orderResponse?.requestedDeliveryDate).format('MMM DD, YYYY'),
							orderDate: moment(orderResponse?.orderDate).format('MMM DD, YYYY hh:mma'),
							requestedDeliveryDate: moment(orderResponse?.requestedDeliveryDate).format(
								'MMM DD, YYYY'
							),
							products: updatedOrderProducts,
						});
						setOrderData({
							...orderResponse,
							cheeniOrderId: cheeniOrderId,
							deliveryDate: moment(orderResponse?.requestedDeliveryDate).format('MMM DD, YYYY'),
							orderDate: moment(orderResponse?.orderDate).format('MMM DD, YYYY hh:mma'),
							requestedDeliveryDate: moment(orderResponse?.requestedDeliveryDate).format(
								'MMM DD, YYYY'
							),
							products: updatedOrderProducts,
						});
						setOrderInfo(order);
						setLoading(false);
						if (updateWidget) {
							setUpdateWidget(false);
						}
						if (apiCall) {
							setApiCall(false);
						}
					},
					(error: AxiosError) => {
						console.log(error);
						displayCustomError(error);
						setLoading(true);
					},
					restaurantId,
					orderId
				);
			}
		}
	}, [updateWidget, apiCall, canViewOrder]);

	//For Mobile Screen
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
	}, []);

	useEffect(() => {
		updateWindowDimensions();
	}, []);
	return (
		<>
			{alert?.message !== '' ? <CustomAlert alert={alert} setAlert={setAlert} /> : null}
			{viewAprovalOrder && !isMobileWidth ? (
				<CustomDrawer
					open={viewAprovalOrder}
					setOpen={setViewAprovalOrder}
					style={{ width: isTabletWidth ? '100%' : '1118px' }}
					header={false}
				>
					{orderDetails && (
						<OrderApproval
							alert={alert}
							setAlert={setAlert}
							orderDetails={orderDetails}
							setOrderDetails={setOrderDetails}
							orderInfo={orderInfo}
							setOrderInfo={setOrderInfo}
							currentUser={currentUser}
							title={orderDetails.firstname}
							handleClose={() => setViewAprovalOrder(false)}
							orders={orders}
							setOrders={setOrders}
							displayCustomError={displayCustomError}
							setApiCall={setApiCall}
							view={view}
							setView={setView}
							products={products}
							setProducts={setProducts}
						/>
					)}
				</CustomDrawer>
			) : (
				viewAprovalOrder && (
					<SlidableDrawer
						isOpen={viewAprovalOrder}
						setIsOpen={setViewAprovalOrder}
						onClose={() => {
							setOrderDetails(null);
							setViewOrder(false);
						}}
					>
						{orderDetails && (
							<OrderApproval
								alert={alert}
								setAlert={setAlert}
								orderDetails={orderDetails}
								setOrderDetails={setOrderDetails}
								orderInfo={orderInfo}
								setOrderInfo={setOrderInfo}
								currentUser={currentUser}
								title={orderDetails.firstname}
								handleClose={() => setViewAprovalOrder(false)}
								orders={orders}
								setOrders={setOrders}
								displayCustomError={displayCustomError}
								setApiCall={setApiCall}
								view={view}
								setView={setView}
								products={products}
								setProducts={setProducts}
							/>
						)}
					</SlidableDrawer>
				)
			)}
			{viewOrder && !isMobileWidth ? (
				<CustomDrawer
					open={viewOrder}
					setOpen={setViewOrder}
					style={{ width: windowDimensions?.width > 800 ? '1118px' : '100%' }}
					header={false}
				>
					<ViewOrder
						orderDetails={orderDetails}
						setOrderDetails={setOrderDetails}
						orderInfo={orderInfo}
						setOrderInfo={setOrderInfo}
						currentUser={currentUser}
						title={orderDetails?.firstname}
						alert={alert}
						setAlert={setAlert}
						handleClose={() => setViewOrder(false)}
						displayCustomError={displayCustomError}
						chatTimeStamp={<Moment date={data?.timestamp} format={dateFormat} unix />}
						setApiCall={setApiCall}
					/>
				</CustomDrawer>
			) : (
				viewOrder && (
					<CustomDrawer
						open={viewOrder}
						setOpen={setViewOrder}
						style={{ width: windowDimensions?.width > 800 ? '1118px' : '100%' }}
						header={false}
					>
						<ViewOrder
							orderDetails={orderDetails}
							setOrderDetails={setOrderDetails}
							orderInfo={orderInfo}
							setOrderInfo={setOrderInfo}
							currentUser={currentUser}
							title={orderDetails?.firstname}
							alert={alert}
							setAlert={setAlert}
							handleClose={() => setViewOrder(false)}
							displayCustomError={displayCustomError}
							chatTimeStamp={<Moment date={data?.timestamp} format={dateFormat} unix />}
							setApiCall={setApiCall}
						/>
					</CustomDrawer>
				)
			)}
			{hideMessages() ? (
				<div
					id={'message_' + data?.id}
					className={'chat__message__outer' + (data?.isFromUs === true ? ' outgoing' : '')}
				>
					{displayDate && <MessageDateIndicator timestamp={data?.timestamp} />}
					<Typography variant="chatMsgFont">
						{data?.type === ChatMessageModel.TYPE_STICKER && (
							<img
								className="chat__media chat__sticker"
								src={data.generateStickerLink()}
								alt={data.caption}
							/>
						)}

						{data?.isFromUs ? (
							<div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										gap: '4px',
										minWidth: '300px',
									}}
								>
									{(displaySender || displayDate) && (
										<PrintMessage className="chat__name" message={data?.senderObject?.name} />
									)}
									<MessageContainer />
								</div>
								<CustomAvatar
									src={data?.senderObject?.image}
									style={{ width: '24px', height: '24px', marginTop: '27px' }}
									className="cursorPointer"
									generateBgColorBy={data?.senderObject?.name}
								>
									{data?.senderObject ? (
										<p style={{ fontSize: '12px' }}>
											{generateInitialsHelper(data?.senderObject?.name)}
										</p>
									) : (
										''
									)}
								</CustomAvatar>
							</div>
						) : (
							<div style={{ display: 'flex', gap: '5px' }}>
								<CustomAvatar
									src={data?.senderObject?.image}
									style={{ width: '24px', height: '24px', marginTop: '27px' }}
									className="cursorPointer"
									generateBgColorBy={data?.senderObject?.name}
								>
									{data?.senderObject ? (
										<p style={{ fontSize: '12px' }}>
											{generateInitialsHelper(data?.senderObject?.name)}
										</p>
									) : (
										''
									)}
								</CustomAvatar>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										gap: '4px',
										minWidth: '300px',
									}}
								>
									{(displaySender || displayDate) && (
										<PrintMessage className="chat__name" message={data?.senderObject?.name} />
									)}
									<MessageContainer />
								</div>
							</div>
						)}
					</Typography>
				</div>
			) : null}
		</>
	);
}

export default ChatMessage;
